import DOMPurify from 'isomorphic-dompurify';
import { useAtom } from 'jotai';
import React from 'react';

import { getCookie } from '@/lib/utils/cookie';
import { sendLog } from '@/lib/utils/send-log';
import { isLoginModalShowAtom, nextPageAfterLoginAtom } from '@/store/login';

import * as S from './style';

export default function Floating({
  floatingText,
  buttonText,
  url,
  isNewTab,
  logTitle,
  hasLoginOption,
}: {
  floatingText: string;
  buttonText: string;
  url: string;
  isNewTab: boolean;
  logTitle: string;
  hasLoginOption: boolean;
}) {
  const setLoginModal = (nextPage: string) => {
    setIsLoginModalShow(true);
    setNextPageAfterLogin(nextPage);
  };
  const checkIsLogin = () => {
    const hasUserInfoCookie = getCookie('userinfo');
    const hasAccessTokenCookie = getCookie('token');

    return hasUserInfoCookie && hasAccessTokenCookie;
  };
  const [, setNextPageAfterLogin] = useAtom(nextPageAfterLoginAtom);
  const [, setIsLoginModalShow] = useAtom(isLoginModalShowAtom);

  const mobileText = floatingText.split(/<br\s*\/?>/i).join('<br>');

  function handleClickFloatingButton() {
    sendLog(logTitle);
    if (!checkIsLogin() && hasLoginOption) {
      setLoginModal(url);
      return;
    }
    isNewTab ? window.open(url, '_blank') : (window.location.href = url);
  }

  return (
    <S.Background>
      <S.Wrapper>
        <S.MobileText
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(mobileText) }}
        />
        <S.DesktopText
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(floatingText) }}
        />
        <S.Cta onClick={handleClickFloatingButton}>{buttonText}</S.Cta>
      </S.Wrapper>
    </S.Background>
  );
}
